<template>
  <div :class="['layer-popup-wrap', isOpen ? 'open' : '']">
    <div class="layer-popup" tabindex="0">
      <h4 class="pop-tit">링크 주소(URL) 생성</h4>
      <div class="pop-cont">
        <div class="info-txt">
          <ul>
            <li>‘링크 주소(URL) 생성’ 기능은 고객님게서 현재 해당 통계표에 적용하신(조회조건, 피봇 등) 내역을 다음 방문때에 조회 설정 없이 이용하실 수 있도록 URL을 배포하는 부가서비스 입니다.
            </li>
            <li>문화셈터의 통계를 자주 활용하시는 고객은 생성되는 URL을 즐겨찾기 하신 후 활용하시는 것을 추천드립니다.</li>
          </ul>
        </div>
        <div class="url-area">
          <Spinner :loading="loading"></Spinner>
          <div class="url-txt">{{ apiUrl }}</div>
          <div class="pop-btn-box align-r">
            <button type="button" class="pop-btn bg-blue" @click="issue">URL 생성</button>
            <button type="button" class="pop-btn bg-blue" @click="copyUrl">URL 복사</button>
          </div>
        </div>
      </div>
      <button type="button" class="btn-pop-close" @click="close"><span class="hidden">닫기</span></button>
    </div>
  </div>
</template>

<script>

import {issueAccessId} from "@/api/my-stats";
import Spinner from "@/components/Spinner";

export default {
  name: "MyStatsPopup",

  components: {
    Spinner
  },

  props: {
    statsId: {
      type: String
    },

    statsName: {
      type: String
    },
  },

  data() {
    return {
      isOpen: false,
      apiUrl: '',
      parameters: {},
      loading: false
    }
  },

  methods: {
    reset() {
      this.apiUrl = '';
      this.parameters = {};
    },

    open(parameters = {}) {
      this.reset();
      this.isOpen = true;
      this.parameters = parameters;
      document.body.style.overflow = 'hidden';
    },

    close() {
      this.$nextTick(() => {
        this.isOpen = false;
        document.body.style.overflow = '';
      })

      // 웹접근성 레이어 팝업 키보드 초점
      this.$parent.popBtn.focus()
    },

    issue() {
      this.loading = true;
      issueAccessId(this.statsId, this.statsName, this.parameters).then(result => {
        this.apiUrl = result;
        this.loading = false;
      })
    },

    setParameters(value) {
      this.parameters = value;
    },

    getParameters() {
      return this.parameters;
    },

    appendParameter(value) {
      Object.assign(this.parameters, value);
    },

    copyUrl() {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.apiUrl).then(() => {
          alert('URL 복사 완료');
        }).catch(err => {
          console.error("copyUrl err", err);
        });
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = this.apiUrl;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        try {
          document.execCommand('copy');
          alert('URL 복사 완료');
        } catch (err) {
          console.error("copyUrl fallback err", err);
        }
        document.body.removeChild(textarea);
      }
    },

  },
}
</script>

<style scoped>

</style>
